import { TravelerAvailableDocumentTypes } from 'common/graphql/__generated__/TravelerAvailableDocumentTypes';
import React from 'react';
import { Traveler_traveler } from '../../../__generated__/Traveler';
import { AttachFormModal } from './AttachFormModal';
import { useFormContext } from 'react-hook-form';
export interface AttachFormProps {
  availableDocumentTypes: TravelerAvailableDocumentTypes | undefined;
  traveler: Traveler_traveler;
}

export const AttachForm: React.FC<AttachFormProps> = ({
  traveler,
  availableDocumentTypes,
}) => {
  const { formState: { isDirty } } = useFormContext();

  return (
   
        <AttachFormModal
          traveler={traveler}
          availableDocumentTypes={availableDocumentTypes}
          isDirty={isDirty}
        />
      
   
  );
};
